var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63.4482,
    height: 45.448769,
    viewBox: "0 0 63.4482 45.448769",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "filled-bracket",
    d: "M 0,5.0501075 C 0,2.2611575 2.26089,2.6747e-4 5.04983,2.6747e-4 H 40.3987 c 2.7889,0 5.0498,2.26089003 5.0498,5.04983003 v 2.24758 c 0,1.68843 -0.8438,3.2651895 -2.2487,4.2016895 l -1.5026,1.0018 c -1.4049,0.9365 -2.2487,2.5133 -2.2487,4.2017 v 11.0948 c 0,1.6884 0.8438,3.2652 2.2487,4.2017 l 1.5026,1.0018 c 1.4049,0.9365 2.2487,2.5133 2.2487,4.2017 v 3.1961 c 0,2.7889 -2.2609,5.0498 -5.0498,5.0498 H 5.04984 C 2.26089,45.448767 0,43.187867 0,40.398967 Z",
    fill: "#c4c4c4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "inner-arrow",
    d: "m 15.6001,10.450467 5.3513,5.6486 -5.3513,5.6487",
    stroke: "#1e1e1e",
    strokeWidth: 3.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "inner-arrow",
    d: "m 25.39,16.351867 h 0.11 c 3.0376,0 5.5,2.4624 5.5,5.5 v 6.8378 c 0,3.0376 -2.4624,5.5 -5.5,5.5 h -11 c -3.0376,0 -5.5,-2.4624 -5.5,-5.5 v -6.9478 c 0,-2.9769 2.4132,-5.39 5.39,-5.39 v 0 h 6.27",
    stroke: "#1e1e1e",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "filled-bracket",
    d: "m 63.4482,40.398667 c 0,2.789 -2.2608,5.0498 -5.0498,5.0498 h -5.3488 c -2.789,0 -5.0499,-2.2608 -5.0499,-5.0498 v -2.2476 c 0,-1.6884 0.8439,-3.2651 2.2487,-4.2017 l 1.5026,-1.0017 c 1.4049,-0.9366 2.2487,-2.5133 2.2487,-4.2017 v -11.0949 c 0,-1.6884 -0.8438,-3.2651 -2.2487,-4.2017 l -1.5026,-1.0017 c -1.4048,-0.9366 -2.2487,-2.5133195 -2.2487,-4.2017495 v -3.19608 c 0,-2.78895 2.2609,-5.049834397 5.0499,-5.049834153 L 58.3984,0 c 2.789,2.44e-7 5.0498,2.2608875 5.0498,5.0498375 z",
    fill: "#c4c4c4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoop);
export default __webpack_public_path__ + "static/media/Loop.fec64dd241bfe076a8436a4df8d6d1cd.svg";
export { ForwardRef as ReactComponent };